import { h } from "@stencil/core";
import { eagerLargeModel, importObjectsModel, lazyLoadItemsDictionary, kbExplorerModel, preferencesModel } from "../../../pages/assets/models/tree.js";
import { GXWebModel } from "../../../pages/assets/models/action-group.js";
const MENU_BAR = "menu-bar";
const KB_EXPLORER = "kb-explorer";
const PREFERENCES = "preferences";
const HEAVY_TREE = "heavy-tree";
const START_PAGE = "start-page";
const GRID = "Grid";
const STRUCT_EDITOR = "StructEditor";
const ATTRS_CONTAINERS_AND_OTHERS = "AttrsContainersAndOthers";
const PROPERTIES = "properties";
const OUTPUT = "output";
const IMPORT_OBJECTS = "import-objects";
export const defaultLayout = {
    id: "root",
    direction: "rows",
    items: [
        {
            id: "sub-group-1",
            accessibleRole: "banner",
            size: "32px",
            viewType: "blockStart",
            widgets: [{ id: MENU_BAR, name: MENU_BAR }]
        },
        {
            id: "sub-group-2",
            direction: "columns",
            size: "1fr",
            items: [
                {
                    id: "sub-group-2-1",
                    accessibleRole: "complementary",
                    expanded: true,
                    size: "300px",
                    viewType: "inlineStart",
                    selectedWidgetId: KB_EXPLORER,
                    widgets: [
                        {
                            id: KB_EXPLORER,
                            name: "KB Explorer",
                            startImageSrc: "assets/icons/toolbar/kb-explorer.svg"
                        },
                        {
                            id: PREFERENCES,
                            name: "Preferences",
                            startImageSrc: "assets/icons/toolbar/preferences.svg"
                        },
                        {
                            id: HEAVY_TREE,
                            name: "Heavy Tree",
                            startImageSrc: "assets/icons/toolbar/kb-explorer.svg"
                        }
                    ]
                },
                {
                    id: "sub-group-2-2",
                    accessibleRole: "main",
                    size: "1fr",
                    viewType: "main",
                    selectedWidgetId: START_PAGE,
                    widgets: [
                        { id: START_PAGE, name: "Start Page" },
                        { id: GRID, name: "Grid" },
                        { id: STRUCT_EDITOR, name: "Struct Editor" }
                    ]
                },
                {
                    id: "sub-group-2-3",
                    accessibleRole: "complementary",
                    expanded: true,
                    size: "300px",
                    viewType: "inlineEnd",
                    widgets: [
                        {
                            id: PROPERTIES,
                            name: "Properties",
                            startImageSrc: "assets/icons/toolbar/properties.svg"
                        }
                    ]
                }
            ]
        },
        {
            id: "sub-group-3",
            accessibleRole: "contentinfo",
            size: "200px",
            viewType: "blockEnd",
            widgets: [
                {
                    id: OUTPUT,
                    name: "Output",
                    startImageSrc: "assets/icons/toolbar/output.svg"
                }
            ]
        }
    ]
};
export const layout2 = {
    id: "root",
    direction: "rows",
    items: [
        {
            id: "sub-group-1",
            accessibleRole: "banner",
            dragBar: { hidden: true },
            size: "32px",
            viewType: "blockStart",
            widgets: [{ id: MENU_BAR, name: MENU_BAR }]
        },
        {
            id: "sub-group-2",
            direction: "columns",
            size: "1fr",
            items: [
                {
                    id: "sub-group-2-1",
                    accessibleRole: "complementary",
                    expanded: true,
                    size: "300px",
                    viewType: "inlineStart",
                    selectedWidgetId: KB_EXPLORER,
                    widgets: [
                        {
                            id: KB_EXPLORER,
                            name: "KB Explorer",
                            startImageSrc: "assets/icons/toolbar/kb-explorer.svg"
                        },
                        {
                            id: PREFERENCES,
                            name: "Preferences",
                            startImageSrc: "assets/icons/toolbar/preferences.svg"
                        },
                        {
                            id: HEAVY_TREE,
                            name: "Heavy Tree",
                            startImageSrc: "assets/icons/toolbar/kb-explorer.svg"
                        }
                    ]
                },
                {
                    id: "sub-group-2-2",
                    direction: "columns",
                    size: "1fr",
                    accessibleRole: "main",
                    items: [
                        {
                            id: "sub-group-2-2-1",
                            size: "1fr",
                            viewType: "main",
                            selectedWidgetId: START_PAGE,
                            widgets: [{ id: START_PAGE, name: "Start Page" }]
                        },
                        {
                            id: "sub-group-2-2-2",
                            size: "1fr",
                            viewType: "main",
                            widgets: [
                                { id: GRID, name: "Grid" },
                                { id: STRUCT_EDITOR, name: "Struct Editor" }
                            ]
                        }
                    ]
                },
                {
                    id: "sub-group-2-3",
                    accessibleRole: "complementary",
                    expanded: true,
                    size: "300px",
                    viewType: "inlineEnd",
                    widgets: [
                        {
                            id: PROPERTIES,
                            name: "Properties",
                            startImageSrc: "assets/icons/toolbar/properties.svg"
                        }
                    ]
                }
            ]
        },
        {
            id: "sub-group-3",
            accessibleRole: "contentinfo",
            size: "200px",
            viewType: "blockEnd",
            widgets: [
                {
                    id: OUTPUT,
                    name: "Output",
                    startImageSrc: "assets/icons/toolbar/output.svg"
                }
            ]
        }
    ]
};
export const layout3 = {
    id: "root",
    direction: "rows",
    items: [
        {
            id: "sub-group-1",
            accessibleRole: "banner",
            dragBar: { hidden: true },
            size: "32px",
            viewType: "blockStart",
            widgets: [{ id: MENU_BAR, name: MENU_BAR }]
        },
        {
            id: "sub-group-2",
            direction: "columns",
            size: "1fr",
            items: [
                {
                    id: "sub-group-2-1",
                    accessibleRole: "complementary",
                    expanded: true,
                    size: "300px",
                    viewType: "inlineStart",
                    selectedWidgetId: KB_EXPLORER,
                    widgets: [
                        {
                            id: KB_EXPLORER,
                            name: "KB Explorer",
                            startImageSrc: "assets/icons/toolbar/kb-explorer.svg"
                        },
                        {
                            id: PREFERENCES,
                            name: "Preferences",
                            startImageSrc: "assets/icons/toolbar/preferences.svg"
                        },
                        {
                            id: HEAVY_TREE,
                            name: "Heavy Tree",
                            startImageSrc: "assets/icons/toolbar/kb-explorer.svg"
                        }
                    ]
                },
                {
                    id: "sub-group-2-2",
                    direction: "rows",
                    size: "1fr",
                    items: [
                        {
                            id: "sub-group-2-2-1",
                            direction: "columns",
                            dragBar: { part: "visible", size: 1 },
                            size: "1fr",
                            accessibleRole: "main",
                            items: [
                                {
                                    id: "sub-group-2-2-1-1",
                                    dragBar: { part: "visible", size: 1 },
                                    size: "0.5fr",
                                    viewType: "main",
                                    selectedWidgetId: START_PAGE,
                                    widgets: [{ id: START_PAGE, name: "Start Page" }]
                                },
                                {
                                    id: "sub-group-2-2-1-2",
                                    direction: "rows",
                                    size: "0.5fr",
                                    viewType: "main",
                                    items: [
                                        {
                                            id: "sub-group-2-2-1-2-1",
                                            dragBar: { part: "visible", size: 1 },
                                            size: "0.5fr",
                                            viewType: "main",
                                            widgets: [
                                                { id: GRID, name: "Grid" },
                                                { id: STRUCT_EDITOR, name: "Struct Editor" },
                                                {
                                                    id: ATTRS_CONTAINERS_AND_OTHERS,
                                                    name: "AttrsContainersAndOthers"
                                                }
                                            ]
                                        },
                                        {
                                            id: "sub-group-2-2-1-2-2",
                                            size: "0.5fr",
                                            viewType: "main",
                                            widgets: [{ id: IMPORT_OBJECTS, name: "Import Objects" }]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            id: "sub-group-2-2-2",
                            accessibleRole: "contentinfo",
                            size: "200px",
                            viewType: "blockEnd",
                            widgets: [
                                {
                                    id: OUTPUT,
                                    name: "Output",
                                    startImageSrc: "assets/icons/toolbar/output.svg"
                                }
                            ]
                        }
                    ]
                },
                {
                    id: "sub-group-2-3",
                    accessibleRole: "complementary",
                    expanded: true,
                    size: "300px",
                    viewType: "inlineEnd",
                    widgets: [
                        {
                            id: PROPERTIES,
                            name: "Properties",
                            startImageSrc: "assets/icons/toolbar/properties.svg"
                        }
                    ]
                }
            ]
        }
    ]
};
const lazyLoadTreeItems = (modelId) => new Promise(resolve => {
    const lazyModelResultFromDictionary = lazyLoadItemsDictionary[modelId];
    setTimeout(() => {
        resolve(lazyModelResultFromDictionary || []);
    }, 50); // Resolves or rejects after 50 milliseconds
});
export const layoutRenders = {
    [MENU_BAR]: () => (h("ch-action-group-render", { model: GXWebModel })),
    [KB_EXPLORER]: () => (h("ch-tree-view-render", { treeModel: kbExplorerModel, lazyLoadTreeItemsCallback: lazyLoadTreeItems, multiSelection: true, showLines: "last" })),
    [PREFERENCES]: () => (h("ch-tree-view-render", { treeModel: preferencesModel, dragDisabled: true, dropDisabled: true, editableItems: false, lazyLoadTreeItemsCallback: lazyLoadTreeItems, multiSelection: true, showLines: "all" })),
    [START_PAGE]: () => (h("div", null, h("h1", { style: {
            display: "flex",
            justifyContent: "center",
            fontSize: "64px",
            color: "#c5c8c6",
            "text-align": "center"
        } }, "GeneXus"))),
    [GRID]: () => (h("div", null, "Grid render... ", h("input", { type: "text" }), h("ch-grid", null, h("ch-grid-columnset", null, h("ch-grid-column", { "column-name": "Name", settingable: false, "column-type": "tree", freeze: "start", size: "20%" }), h("ch-grid-column", { "column-name": "Type", settingable: false, size: "80%" }), h("ch-grid-column", { "column-name": "Description", settingable: false, size: "500px" }), h("ch-grid-column", { "column-name": "Is Collection", settingable: false, size: "100px" })), h("ch-grid-row", null, h("ch-grid-cell", null, "Target"), h("ch-grid-cell", null), h("ch-grid-cell", null, "Target"), h("ch-grid-cell", null, "false"), h("ch-grid-rowset", null, h("ch-grid-row", { leaf: "false" }, h("ch-grid-cell", null, "TargetType"), h("ch-grid-cell", null, "TargetType, GeneXus.Common.Notifications"), h("ch-grid-cell", null, "Target Type (required)"), h("ch-grid-cell", null, "false")), h("ch-grid-row", null, h("ch-grid-cell", null, "Devices"), h("ch-grid-cell", null), h("ch-grid-cell", null, "Devices List"), h("ch-grid-cell", null, "true"), h("ch-grid-rowset", null, h("ch-grid-row", null, h("ch-grid-cell", null, "Device"), h("ch-grid-cell", null), h("ch-grid-cell", null), h("ch-grid-cell", null), h("ch-grid-rowset", null, h("ch-grid-row", null, h("ch-grid-cell", null, "DeviceToken"), h("ch-grid-cell", null, "Character(500)"), h("ch-grid-cell", null, "DeviceToken"), h("ch-grid-cell", null, "false")))))), h("ch-grid-row", null, h("ch-grid-cell", null, "Groups"), h("ch-grid-cell", null), h("ch-grid-cell", null, "Groups"), h("ch-grid-cell", null, "true"), h("ch-grid-rowset", null, h("ch-grid-row", null, h("ch-grid-cell", null, "Group"), h("ch-grid-cell", null), h("ch-grid-cell", null), h("ch-grid-cell", null), h("ch-grid-rowset", null, h("ch-grid-row", null, h("ch-grid-cell", null, "Name"), h("ch-grid-cell", null, "Character(100)"), h("ch-grid-cell", null, "Name"), h("ch-grid-cell", null, "false")))))), h("ch-grid-row", null, h("ch-grid-cell", null, "Targets"), h("ch-grid-cell", null), h("ch-grid-cell", null, "Targets"), h("ch-grid-cell", null, "true"), h("ch-grid-rowset", null, h("ch-grid-row", null, h("ch-grid-cell", null, "Filter"), h("ch-grid-cell", null), h("ch-grid-cell", null), h("ch-grid-cell", null), h("ch-grid-rowset", null, h("ch-grid-row", null, h("ch-grid-cell", null, "Name"), h("ch-grid-cell", null, "Character(100)"), h("ch-grid-cell", null, "Name"), h("ch-grid-cell", null, "false")), h("ch-grid-row", null, h("ch-grid-cell", null, "Value"), h("ch-grid-cell", null, "Character(100)"), h("ch-grid-cell", null, "Name"), h("ch-grid-cell", null, "false"))))))))))),
    [STRUCT_EDITOR]: () => (h("div", null, "Struct Editor... ", h("input", { type: "text" }))),
    [ATTRS_CONTAINERS_AND_OTHERS]: () => (h("div", null, "Panel AttrsContainersAndOthers ", h("input", { type: "text" }))),
    [PROPERTIES]: () => (h("div", null, "Properties render... ", h("input", { type: "text" }))),
    [OUTPUT]: () => h("div", null, "Output render... "),
    [HEAVY_TREE]: () => (h("ch-tree-view-render", { treeModel: eagerLargeModel, dragDisabled: true, dropDisabled: true, editableItems: false, multiSelection: true, showLines: "all" })),
    [IMPORT_OBJECTS]: () => (h("ch-tree-view-render", { treeModel: importObjectsModel, checkbox: true, checked: true, lazyLoadTreeItemsCallback: lazyLoadTreeItems, toggleCheckboxes: true, dragDisabled: true, dropDisabled: true, editableItems: false, multiSelection: true, showLines: "all" }))
};
//# sourceMappingURL=renders.js.map
